import { Spinner } from "@justworkshr/milo-core";

const FullPageSpinner = () => (
  <div className="milo--grid">
    <Spinner />
  </div>
);
export default FullPageSpinner;
